import { get } from "lodash";
import { defaultField, isContainedInList, subStringDollarFormat } from "helpers/row-logic-helper";
import { LOAN_RATE_TYPES } from "@loanbossinc/component-library";

export const lendersMapNestedRows = loan => {
  const loanProvider = defaultField(loan, "details.loanProvider");

  return loanProvider.reduce((accum, provider) => {
    if (!provider) {
      return accum;
    }

    const allocated = subStringDollarFormat(provider, "loanCompanyBridge.lenderAllocation");
    const isLead = get(provider, "loanCompanyBridge.isLead");
    const companyContact = get(provider, "loanCompanyBridge.companyContact");
    const lenderType = get(provider, "loanCompanyBridge.lenderType.name");

    accum.push({
      name: defaultField(provider, "name"),
      lenderType,
      allocated: allocated ? `${allocated} allocated` : undefined,
      isLead: isLead ? "Lead" : undefined,
      companyContact: companyContact ? companyContact.fullName : undefined
    });

    return accum;
  }, []);
};

export const shouldShowRateReductionTerms = loan => isContainedInList(loan, "details.spreadReductionTerms", [
  LOAN_RATE_TYPES.FIXED
]);

export const shouldShowServicerCompany = loan => Boolean(get(loan, "details.servicerCompany"));

export const shouldShowLoanReferenceNumber = loan => Boolean(get(loan, "details.loanReferenceNumber"));

export const shouldShowCounterparty = loan => Boolean(get(loan, "details.counterparty"));

export const shouldShowLoanSeniority = loan => Boolean(get(loan, "details.loanSeniority"));

export const shouldShowLoanStatus = loan => Boolean(get(loan, "details.loanStatus"));

export const shouldShowLoanType = loan => Boolean(get(loan, "details.loanType"));

export const shouldShowDefaultInterestSpread = loan => Boolean(get(loan, "details.defaultInterestSpread"));

export const shouldShowRecurringCosts = loan => Boolean(get(loan, "details.recurringCosts"));

export const shouldShowCollateralization = loan => Boolean(get(loan, "details.collateralization"));

export const shouldShowLoanField = (loan, fieldName) => Boolean(get(loan, fieldName, false));

